// extracted by mini-css-extract-plugin
module.exports = {"banner":"ArchivesPromotionBanner_banner__3VtJn"};